export interface NotificationInterface {
  id: string;
  description: string;
  message: string;
  notificationType: NotificationType;
  changeType: NotificationChangeType;
  apiToCall: string[];
}

export enum NotificationType {
  Task = 0,
  Message = 1,
  Risks = 2,
  Plans = 3,
  Policies = 4,
  Controls = 5,
  DisoTasks = 6,
  Assets = 7,
}

export enum NotificationChangeType {
  Created = 0,
  Updated,
  Deleted,
  RiskStatus,
  RiMSChanged,
  SolutionMapping,
  TargetDate,
  ScheduledApprovalRequired,
  UserReviewalRequired,
}
